export abstract class Details {
  protected constructor() {
  }

  protected abstract showActions(): boolean;
}
